import {
  AttributeItem,
  AttributeLabel,
  AttributeValue,
} from '../../../../Blends.styled'
import { Tooltip } from '@mui/material'
import {
  isNumberOutOfRange,
  roundToOneDecimal,
} from '../../../../../../utils/helpers'
import React from 'react'
import { TAttribute } from '../../../../../../types'

export const BlendAttributeItem = ({
  attribute,
  labelWidth,
}: {
  attribute: TAttribute
  labelWidth?: string
}) => {
  const { name, value, std } = attribute

  const roundedValue = roundToOneDecimal(value)
  const roundedStd = roundToOneDecimal(std)
  const tooltipMin = roundToOneDecimal(value - std)
  const tooltipMax = roundToOneDecimal(value + std)

  return (
    <AttributeItem key={name}>
      <AttributeLabel sx={{ width: labelWidth || 'unset' }}>
        {name}
      </AttributeLabel>
      {value != null && (
        // Tooltip range values are temporarily hidden until verified how it's calculated in BE to be in sync
        // <Tooltip title={`${tooltipMin} - ${tooltipMax}`}>
        <AttributeValue
          sx={{
            color: isNumberOutOfRange(
              Number(attribute.range_min),
              Number(attribute.range_max),
              value
            )
              ? (theme) => theme.palette.error.main
              : (theme) => theme.palette.text.primary,
          }}
        >
          <span>{roundedValue}</span>
          <sup>±</sup>
          <sup>{roundedStd}</sup>
        </AttributeValue>
        // </Tooltip>
      )}
    </AttributeItem>
  )
}
